import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader'
import { BriefPage } from '#features/briefs/brief-page.tsx'

export const Route = createFileRoute('/_app/$workspace/_dashboard/briefs/$id')({
  head: () => ({ meta: [{ title: 'Edit brief' }] }),
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const params = Route.useParams()
  return <BriefPage params={params} />
}
